export function Footer() {
  return (
    <footer className="pt-6 pb-10 border-t border-white/[0.04] mt-8">
      <p className="text-xs text-ink-dim max-w-md leading-relaxed">
        你的代币和 LP 永远在你自己钱包里，蜂鸟不托管任何资产。这个页面只展示链上数据并帮你领奖励。
      </p>
    </footer>
  );
}
